// import React from 'react';
import { Box } from '@mui/material';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Hero from './Hero';
// import ApplicationForm from './ApplicationForm';
import ApplicationClosed from './ApplicationClosed';

function Apply() {
    return (
        <Box>
            <Header />
            <Hero />
            {/* <ApplicationForm /> */}
            <ApplicationClosed />
            <Footer />
        </Box>
    );
}

export default Apply;
